// extracted by mini-css-extract-plugin
export default {"container":"S01_container__tan8y","limiter":"S01_limiter__+EJx1","title":"S01_title__ioNeM","text":"S01_text__pzm5J"};